<template>
  <b-container class="specialty-list">
    <h2>Settings</h2>

    <DataTable
      ref="dataTable"
      :show-filters="true"
      :show-pager="true"
      :get-items="getSettings"
      :filters="filters"
      :filter-title="'Filter Settings'"
      :fields="fields"
    >
      <!-- template for filters -->
      <template slot="filters">
        <b-row>
          <b-col>
            <b-form-input v-model="filters.key.value" placeholder="Key" />
          </b-col>
          <b-col>
            <b-form-select
              v-model="filters.side.value"
              :options="sideOptions"
            />
          </b-col>
        </b-row>
      </template>

      <!-- templates for custom columns -->
      <template slot="key" slot-scope="data">
        <strong>{{ data.item.key }}:</strong>
        <br />
        {{ data.item.key }}
      </template>
      <template slot="value" slot-scope="data">
        <strong>{{ data.item.value }}:</strong>
        <br />
        {{ data.item.value }}
      </template>
      <template slot="actions" slot-scope="data">
        <b-button
          split
          variant="info"
          size="sm"
          @click="editSetting(data.item.key)"
        >
          Edit
        </b-button>
      </template>
    </DataTable>

    <v-wait for="loading">
      <HalfCircleSpinner slot="waiting" />
      <template slot="waiting">
        <div class="spinner-message my-3 text-center">
          Loading the settings...
        </div>
      </template>
    </v-wait>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import DataTable from '@/components/DataTable.vue';
import Api from '@/providers/Api.js';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'SettingsList',
  components: {
    DataTable,
    HalfCircleSpinner,
  },
  data() {
    return {
      filters: {
        key: { field: 'key', type: 'string', value: null },
        side: { field: 'side', type: 'string', value: '' },
      },
      fields: [
        { key: 'key', sortable: true, label: 'Key' },
        { key: 'value', sortable: false, label: 'Value' },
        { key: 'actions', sortable: false, custom: true },
      ],
    };
  },
  computed: {
    sideOptions() {
      return {
        '': 'All',
        '1': 'Frontend',
        '2': 'Backend',
      };
    },
  },
  methods: {
    editSetting(key) {
      this.$router.push(`/admin/settings/edit/${key}`);
    },
    getSettings(listParams) {
      return Api.getSettingsList(this, this.filters, listParams);
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
